import { setup } from '@tcc/i18n';
import { setupI18n } from '@tcc/field-guide';
import { BootNames } from '../types/bootNames';
import englishFile from '../i18n/en.json';

export const i18n = {
  name: BootNames.i18n,
  installer: async () => Promise.all([
    setup({
      project: 'field-view',
      englishFile,
    }),
    setupI18n()]),
};
